import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "No I-90 drive to Chicago — we handle agency submission",
      "Ideal for Sanford Health international travelers",
      "Perfect for Sioux Falls business professionals",
      "Great for Augustana University & USF students studying abroad",
      "Sioux Falls Regional Airport (FSD) flyers",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no Chicago drive required",
      "Faster than self-service at Sioux Falls post offices",
      "Good for planned international trips from FSD",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "Sioux Falls USPS is primary acceptance facility",
      "No document review — errors cause rejection and restart",
      "In-person clerk appointment required at Minnehaha County facilities",
      "South Dakota mail routing adds extra transit days",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "No passport agency in South Dakota — closest is Chicago, ~575 miles via I-90",
      "8+ hour drive to Chicago Passport Agency",
      "NPIC appointment required — no walk-ins at Chicago agency",
      "Life-or-death emergencies only with documentation",
      "Remote location makes same-day Chicago trips impractical",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function ProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      cityName="Sioux Falls"
      headingExtra="SD"
      introText="Sioux Falls residents have multiple paths to a passport — but South Dakota has zero passport agencies anywhere in the state, which makes last-minute and emergency processing a serious logistical challenge. The nearest agency is Chicago — 575 miles east via I-90. Here's how each option stacks up."
      options={options}
      emergencyDescription="Strictly for documented life-or-death emergencies. The closest passport agency is the Chicago Passport Agency at 230 S Dearborn St Suite 380, Chicago IL 60604 — approximately 575 miles, 8 hours via I-90. South Dakota has no passport agency. NPIC appointment required."
      disclaimerText="*Processing speed depends on eligibility and documentation. Not all applicants qualify for Regional Agency Processing. South Dakota has no passport agency — nearest is Chicago, IL (~575 miles)."
    />
  );
}